/**
 * Trainings TT slider script
 */
 class ME_SliderTT {
	constructor() {
		this.initState();
		this.initEvents();
	}

	initState() {
		this.slider = $('#tt-slider');
		this.wrapper= $('.tt-slider');
		this.content = $('.tt-slider-content');
		this.thumb = $('.tt-thumb');
		this.image = $('.tt-slider-image');
		this.slides = $('.tt-slider-slide');
		this.currentSlide = 1;
		this.next = $('.tt-slider-next');
		this.prev = $('.tt-slider-prev');
		this.animating
	}

	initEvents() {
		if (!this.wrapper.length) {
			return
		}

    this.moveToNewSlide(1, 1)

    this.next.on('click', (e) => {
      e.preventDefault()
      this.moveToNewSlide(this.currentSlide, this.currentSlide + 1)
    })

    this.prev.on('click', (e) => {
      e.preventDefault()
      this.moveToNewSlide(this.currentSlide, this.currentSlide - 1)
    })

    this.wrapper.on('scroll', (e) => {
			let maxWWidth = this.content.outerWidth() - this.wrapper.outerWidth()
			let offsetLeft = e.target.scrollLeft;
			let percent = (100 * offsetLeft) / maxWWidth
			let imageWidth = this.image.outerWidth()
			let newSlide = Math.ceil(percent / 100 * this.slides.length);
      let ele = document.getElementById('tt-thumb')

      if (this.currentSlide === 1) {
        this.prev.removeClass('active')
      } else {
        this.prev.addClass('active')
      }

      if (this.currentSlide === this.slides.length) {
        this.next.removeClass('active')
      } else {
        this.next.addClass('active')
      }

      if (newSlide !== this.currentSlide && ele.style.cursor !== 'grabbing' && !this.animating && newSlide > 0 && jQuery(window).outerWidth() > 760) {
        this.moveToNewSlide(this.currentSlide, newSlide);
      }

      this.image.css('transform', 'translate(' + (-(percent * (imageWidth - this.content.outerWidth())) / 100) + 'px, 0)')
      this.thumb.css('left', (percent * 0.7) + '%')

      this.currentSlide = newSlide > 0 ? newSlide : 1;
      $('.slide-number .current').html(this.currentSlide < 1 ? 1 : this.currentSlide)
    })

    if (jQuery(window).outerWidth() <= 760){
      this.slider.on('swipeleft', (e) => {
        e.preventDefault()
        this.moveToNewSlide(this.currentSlide, this.currentSlide + 1)
      })

      this.slider.on('swiperight', (e) => {
        e.preventDefault()
        this.moveToNewSlide(this.currentSlide, this.currentSlide - 1)
      })
    }

		document.addEventListener('DOMContentLoaded', () => {
			const ele = document.getElementById('tt-slider');
			if (jQuery(window).outerWidth() > 760 && ele) {
				this.grabToSlide(ele);
			}
		});

		document.addEventListener('DOMContentLoaded', () => {
			const ele = document.getElementById('tt-thumb');
			if (jQuery(window).outerWidth() > 760 && ele) {
				this.grabToSlide(ele);
			}
		});
	}

	grabToSlide(ele) {
		ele.style.cursor = 'grab';

		let pos = {top: 0, left: 0, x: 0, y: 0};

		const mouseDownHandler = (e) => {
			if (!this.animating) {
				ele.style.cursor = 'grabbing';
				ele.style.userSelect = 'none';

				pos = {
					left: ele.scrollLeft,
					top: ele.scrollTop,
					// Get the current mouse position
					x: e.clientX,
					y: e.clientY,
				};

			}
			document.addEventListener('mousemove', mouseMoveHandler);
			document.addEventListener('mouseup', mouseUpHandler);
		};

		const mouseMoveHandler = (e) => {
			if (!this.animating) {
				// How far the mouse has been moved
				const dx = e.clientX - pos.x;
				const dy = e.clientY - pos.y;

				// Scroll the element
				ele.scrollTop = pos.top - dy;
				ele.scrollLeft = pos.left - dx;
			}
		};

		const mouseUpHandler = () => {
			if (!this.animating) {
				ele.style.cursor = 'grab';
				ele.style.removeProperty('user-select');
			}
			document.removeEventListener('mousemove', mouseMoveHandler);
			document.removeEventListener('mouseup', mouseUpHandler);
		};

		// Attach the handler
		ele.addEventListener('mousedown', mouseDownHandler);
	}

	moveToNewSlide(slide, newSlide) {
		this.animating = true;
		let nextSlide = this.slides.eq(newSlide > slide ? slide : (newSlide - 1));
		let newSlidePosition = nextSlide.position().left + (nextSlide.outerWidth()/2) - ($(window).outerWidth()/2)
	
		this.slider.animate({scrollLeft: newSlidePosition}, 800);
		setTimeout(() => {
			this.animating = false;
		}, 800)
	};	
}
